<template>
  <nav class="Navigation menu-list" id="nav">
    <router-link class="nav-item" to="/">Home</router-link>
    <router-link class="nav-item" to="/about">About</router-link>
    <router-link class="nav-item" to="/resume">Resume</router-link>
    <router-link class="nav-item" to="/contact">Contact</router-link>
  </nav>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.Navigation {

  .nav-item {
    color: $greenDark;
    direction: rtl;

    &:hover {
      background-color: $green;
    }
  }

  a {
    font-weight: bold;
    color: $greenDark;

    &.router-link-exact-active {
      color: $green;
    }
  }

  li {
    color: $greenDark;
    display: block;
  }
}
</style>
